import { Store } from 'vuex';
import { namespace } from 'vuex-class';
import { configuration } from '@/configuration';
import localizationService, { localizationModuleKey } from '@step/localization/src';
import localizationProvider from '@step/localization/src/localization/dxLocalizationProvider';
import authorizationService, { authorizationModuleKey, IGetUserInformationResultModel, AuthService } from '@step/auth';
import apiService from '@step/api';
import { AxiosError, AxiosResponse } from 'axios';
import notify from 'devextreme/ui/notify';
import { Profile, User, UserManager, UserManagerSettings } from 'oidc-client';
import { layoutService } from '@step/vue';
import cubejsService from '@/common/cubejsService';
//import mirageTestServer from './mirageTestServer';
import customerService from './common/customerService';
import ColorService from '@/common/colorService';

import {
	IDxUiComponentItem,
	DxMultipleComponentItemType,
	setUpDxDefaultSettings
} from './components';

import { isNil, isString } from 'lodash';

import mitt from 'mitt';

const uiBus = mitt();

const langVuexNamespace = namespace(localizationModuleKey);
const authorizationVuexNamespace = namespace(authorizationModuleKey);

const config: UserManagerSettings = {
	authority: configuration.authAuthority,
	client_id: configuration.authClientId,
	redirect_uri: configuration.authRedirectUri,
	includeIdTokenInSilentRenew: false,
	response_type: 'code',
	response_mode: 'query',
	scope: `openid ${configuration.authScopes}`,
	post_logout_redirect_uri: configuration.authPostLogoutRedirectUri,
	accessTokenExpiringNotificationTime: 30,
	automaticSilentRenew: true,
	silent_redirect_uri: configuration.authSilentRedirectUri
};

const userManager: UserManager = new UserManager(config);
const colorService: ColorService = new ColorService();

const authService = new AuthService();
class Container {
	public init(store: Store<any>): void {
		this.configureApiService();
		localizationService.init({
			initialStore: store,
			localizationProvider,
			downloadLocale: this.downloadLocale//async locale => (await import(/* webpackChunkName: "lang-[request]" */ `@/locales/${'en'/*locale.toLowerCase()*/}`)).default
		});

		setUpDxDefaultSettings({
			localizationService
		});

		authorizationService.init({
			initialStore: store,
			userInformationHandler: this.userInformationHandler
		});
		cubejsService.init({
			apiTokenHandler: async (idCustomer: string) => apiService.get<string>('CubeJs', `GetUserTokenForCustomer/${idCustomer}`),
			cubeJsOptions: { apiUrl: configuration.cubejsApiURL },
			store
		});
		customerService.init({
			store
		});

		authService.init({
			apiService,
			authorizationService,
			localizationService,
			permissions: [],
			userManager
		});

		userManager.events.addUserLoaded(async () => {
			await authorizationService.loadUserInformation();
		});

		layoutService.init({
			authorizationService: authorizationService,
			navbarAppItem: [{
				name: 'admin',
				href: '#',
				disabled: true
			}],
			localizationService: localizationService
		});
	}

	downloadLocale: () => Promise<any> =
		async () => {
			const user = authorizationService.getCurrentUser();
			const customer = customerService.getCustomer();
			if (user) {
				//if ((user) &&  (
				//	customer)){
				return (await apiService.post('Vocabulary', 'GetTranslationList', {
					app: configuration.applicationName,
					languageCode: user.languageCode,
					idCustomer: customer
				}, {
					axiosConfig: {
						baseURL: configuration.tarnslatoryBackendURL
					}
				}));
			} else return null;
		}

	configureApiService(): void {

		//mirageTestServer.init();

		function parseSuccess<T = any | null>(response: AxiosResponse<T>): T | null {
			return response.data !== undefined
				? response.data
				: null;
		}

		function handleError(error: AxiosError<any>): void {
			const msg: string = localizationService.translate(error?.response?.data.Message);
			if (isString(msg))
				notify({ position: 'top', message: msg }, 'error');
			else {
				if (!isNil(error.response))
					notify(error!.response!.data.message, 'error', 5000);
				// notify(error, 'error', 5000);
				//else {
				//
				//}
			}
			throw error;
		}

		apiService.init(
			{
				baseURL: configuration.backendBaseUrl,
				timeout: configuration.apiTimeout,
				headers: { 'Cache-Control': 'no-cache' },
				withCredentials: true
			},
			{
				parseSuccess,
				handleError
			});
	}

	async userInformationHandler(): Promise<IGetUserInformationResultModel> {
		const user: User | null = await userManager.getUser();
		const profile: Profile = user!.profile;
		const currentUser: any = {
			id: profile.id,
			firstName: profile.given_name,
			lastName: profile.family_name,
			fullName: profile.name,
			languageCode: profile.language_code,
			email: profile.email,
			permissions: profile.role,
			role: profile.level
		};
		//const userInfo = await apiService.get('user', 'GetUserDataSegregation', null, { axiosConfig: { baseURL: configuration.authBackendBaseUrl } });
		//currentUser.role = userInfo.RoleCode;
		return { currentUser };
	}
}

export { localizationService, langVuexNamespace };
export { apiService };
export { authorizationService, authorizationVuexNamespace };
export { userManager };
export { cubejsService };
export { customerService };
export { uiBus };
export { colorService };

export {
	IDxUiComponentItem, DxMultipleComponentItemType
};

export default new Container();
